import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { Input } from '@angular/core';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { ToastrService } from 'ngx-toastr';
import { SearchPage } from 'src/app/shared/model/search-page.model';
import { SearchCount } from '../../../model/search-count.model';
import { Subscription } from 'rxjs';
import { SearchConditionService } from '../../../service/search-condition.service';
import { PageEnums } from '../../../enum/page-enums';
import { closeOpen } from 'src/app/shared/animations/open-close.animations';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  animations: [closeOpen()]
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() open: boolean;
  @Input() searchSide: string;
  @Input() searchService: SearchService;
  @Input() id: string;
  @Input() sortParams: object;
  @Input() searchParams: SearchCondition;
  @Input() page; // ページ
  @Output() searching = new EventEmitter<any>();
  @Output() searchFinish = new EventEmitter<any>();

  // 検索ボックスのデフォルトのHeight
  // タグボックスの位置によって可変にする必要がるため変数で管理
  defaultSearchBoxHeight = 48;

  // subscriptions
  private subscriptions: Subscription = new Subscription();

  detailPages: string[] = [PageEnums.worker_detail, PageEnums.project_detail];

  constructor(
    private toastrService: ToastrService,
    private searchConditionService: SearchConditionService
  ) {}

  ngOnInit() {
    this.searchService.setSearchTags([]);
    const searchSub = this.searchService.searchSub.subscribe(SearchParams => {
      const searchRequestSub = this.searchService
        .search(SearchParams.id, SearchParams.additionalParams)
        .subscribe(
          res => {
            // 使用中のseachSearviceの名前からsessionStorageで使用するkey名作成
            const searchParamsKeyName = `${this.searchService.constructor.name}SearchParams`;
            // sessionStorageにページ数の情報保存
            this.setSearchCount(res);
            // sessionStorageに検索窓に入力されたパラメータ保存
            this.setSearchParams(searchParamsKeyName, res);
            // 人材、案件どちらの検索窓を使用したかをsessionStorageに保存
            this.setSearchSide(searchParamsKeyName, res);
            // 値を他コンポーネントに移譲

            this.searchService.searchSubject.next(res.body);
            this.searchFinish.emit();
          },
          error => {
            this.toastrService.error(
              'エラーが発生しました。お手数ですが、再度お試しください'
            );
            this.searchFinish.emit();
          }
        );
      this.subscriptions.add(searchRequestSub);
    });
    this.subscriptions.add(searchSub);

    this.defaultSearchBoxHeight = this.isDetailPage() ? 51 : 48;

    // 検索開始イベント受信時時の処理
    const searchStartSub = this.searchService.searchStartState.subscribe(res => {
      console.log(this.searchParams);
      this.doSearch();
    });
    this.subscriptions.add(searchStartSub);

    // 検索リセットイベント受信時時の処理
    const searchResetSub = this.searchService.searchResetState.subscribe(res => {
      this.resetSearch();
    });
    this.subscriptions.add(searchResetSub);
  }

  ngOnDestroy() {
    sessionStorage.clear();
    this.subscriptions.unsubscribe();
  }

  doSearch() {
    if (
      !this.searchConditionService.areAttributesValidated(this.searchParams)
    ) {
      return;
    }

    // クリック時に条件保存：検索条件をサービスに設定
    this.searching.emit();
    this.searchService.setSearchCondition(this.searchParams);
    this.searchService.setSearchPage(new SearchPage({ page: 1 }));

    this.searchService.search$.next({
      id: this.id,
      additionalParams: {}
    });
  }

  resetSearch() {
    this.searchParams.keyword = '';
    this.searchConditionService.resetSearchCondition(this.searchParams);
    this.searchService.setSearchTags([]);
    this.searchService.setSearchCondition(this.searchParams);
    this.doSearch();
  }
  resetSearchkeyword() {
    this.searchParams.keyword = '';
    this.searchConditionService.resetSearchKeyword(this.searchParams);
    this.searchService.setSearchCondition(this.searchParams);
    this.doSearch();
  }
  resetSearchSkillList() {
    this.searchParams.required_skills = '';
    this.searchService.setSearchCondition(this.searchParams);
    this.doSearch();
  }

  // ページ数情報をresから取得 => sessionStorage保存
  setSearchCount(res: any) {
    const searchCount = new SearchCount({
      startCount: res.body.pageInfo.start_count,
      endCount: res.body.pageInfo.end_count,
      totalCount: res.body.pageInfo.total,
      perPage: this.searchService.getSearchCount().perPage
    });
    this.searchService.setSearchCount(searchCount);
  }

  setSearchParams(searchParamsKeyName: string, res: any) {
    sessionStorage.setItem(
      searchParamsKeyName,
      JSON.stringify(res.body.searchParams)
    );
  }

  // 案件検索か人材検索か判定して保存。
  setSearchSide(searchParamsKeyName: string, res: any) {
    if (searchParamsKeyName.slice(0, 10) === 'SearchAuto') {
      sessionStorage.setItem(
        'searchAutoSearchSide',
        JSON.stringify(res.body.searchParams.activeTabId)
      );
    } else if (searchParamsKeyName.slice(0, 11) === 'SearchOffer') {
      sessionStorage.setItem(
        'searchOfferSearchSide',
        JSON.stringify(res.body.searchParams.activeTabId)
      );
    }
  }

  isDetailPage(): boolean {
    return this.detailPages.includes(this.page);
  }
}
